'use strict';
var populationElements = document.querySelectorAll('.population');
var totalPopulation = 0;
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = populationElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var element = _step.value;
        var populationStr = element.textContent.replace(/,/g, '');
        var populationNum = Number(populationStr);
        if (!Number.isNaN(populationNum)) totalPopulation += populationNum;
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}
var averagePopulation = totalPopulation / populationElements.length;
var totalElement = document.querySelector('.total-population');
var averageElement = document.querySelector('.average-population');
if (totalElement) totalElement.textContent = totalPopulation.toLocaleString('en-US');
if (averageElement) averageElement.textContent = Math.round(averagePopulation).toLocaleString('en-US');

//# sourceMappingURL=js_get_data_DOM.683a95a1.js.map
